<template>
  <el-image
    v-if="props.file_url"
    :src="props.file_url"
    class="rounded-full"
    :class="'w-' + props.size + ' h-' + props.size"
    :preview-src-list="[props.file_url]"
    preview-teleported
  />
  <div
    v-else
    class="rounded-full bg-gray-300 flex items-center justify-center text-white text-lg"
    :class="'w-' + props.size + ' h-' + props.size"
  >
    {{ props.title }}
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

export default {
  props: {
    size: {
      type: String,
      default: 12,
    },
    id: Number,
    file_url: String,
    title: String,
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {});
    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
